import { useState, useEffect } from 'react';

export const useResponsiveHeight = () => {
  const [height, setHeight] = useState('');

  const updateHeight = () => {
    const width = window.innerWidth;

    if (width <= 600) {
      setHeight('400px'); // Mobile
    } else if (width > 600 && width <= 900) {
      setHeight('500px'); // Tablet
    } else if (width > 900 && width <= 2000) {
      setHeight('50vh'); // Web
    } else if (width > 2000 && width <= 3324) {
      setHeight('auto'); // 2K+ screens
    } else {
      setHeight('60vh'); // Fallback
    }
  };

  useEffect(() => {
    updateHeight();
    window.addEventListener('resize', updateHeight);
    console.log("height", height);
    
    return () => window.removeEventListener('resize', updateHeight);

  }, [height]);

  return height;
};
